// What to show after writing one preference row.
//
// The rule is the same one the viewer's applied-generation work settled: a
// control must render what the SERVER stored, not what the page believed it
// sent. This page used to write its own optimistic value and take only setBy
// from the answer, which is indistinguishable from correct until the two
// differ - and they can, because PUT /notification-settings/user/:userId
// answers 200 with `{ raced: true }` AND NO ROW when two writers hit the
// unique index on userId+source at once (the 11000 branch in
// routes/notificationSettings.js). On that path the old code blanked the
// "set for you" attribution and kept a checkbox state it had only assumed.
//
// Its own file so the decision is testable without rendering a 29-row antd
// table, the same reason keyGuard and saveDataUrl are their own files.

// Returns the fields to merge into the row, or NULL meaning "this answer does
// not contain a row - go and read it". Never throws: a malformed answer is a
// re-read, not a crash.
export function rowFromWriteResponse(response) {
  if (!response || typeof response !== 'object') return null;
  // `enabled` is the field that decides it, not `source`: a future answer that
  // adds fields still works, and an answer that omits the state does not.
  if (typeof response.enabled !== 'boolean') return null;
  const out = { enabled: response.enabled, setBy: response.setBy || '' };
  // THE CADENCE QUARTET, COPIED ONLY WHEN THE ANSWER CARRIES IT.
  //
  // rowOut returns seven fields and NOT the display ones - no label, no
  // `when`, no desc - so the caller MERGES this into the row it already has.
  // Copying a key that is absent would write undefined over a value the page
  // has, which is how a merge quietly becomes a replace.
  //
  // `cadenceApplies` is copied on presence rather than on truthiness,
  // because false is the value that matters most.
  for (const k of ['cadence', 'cadences', 'cadenceDefault']) {
    if (k in response) out[k] = response[k];
  }
  if ('cadenceApplies' in response) out.cadenceApplies = !!response.cadenceApplies;
  return out;
}

export default rowFromWriteResponse;
